"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.useAnimation = exports.AnimationProvider = exports.AnimationContext = void 0;
var react_1 = __importStar(require("react"));
var use_debounce_1 = require("use-debounce");
var ANIM_DURATION_MS = 400;
exports.AnimationContext = react_1["default"].createContext({
    isVisible: false,
    isAnimIn: false,
    isAnimOut: false
});
/**
 * Simply applies a css animation to transition a component in and out.
 * When the component is no longer needed, it will no longer be rendered to the
 * dom.
 */
var AnimationProvider = function (_a) {
    var isVisible = _a.isVisible, _b = _a.animationDuration, animationDuration = _b === void 0 ? ANIM_DURATION_MS : _b, otherProps = __rest(_a, ["isVisible", "animationDuration"]);
    var _c = (0, react_1.useState)(false), isAnimIn = _c[0], setIsAnimIn = _c[1];
    var _d = (0, react_1.useState)(false), isAnimOut = _d[0], setIsAnimOut = _d[1];
    var _e = (0, react_1.useState)(false), prevIsOpen = _e[0], setPrevIsOpen = _e[1];
    // Keeps the modal visible while the css animation is completing
    var trackAnimOutCompleted = (0, use_debounce_1.useDebouncedCallback)(function () {
        setIsAnimOut(false);
    }, animationDuration, { leading: false });
    // Allows us to flash the component in an "invisible" state, for one frame.
    // Then set it to "visible". This allows us to make sure the css transition
    // actually works.
    var trackAnimInCompleted = (0, use_debounce_1.useDebouncedCallback)(function () {
        setIsAnimIn(false);
    }, 0, { leading: false });
    if (isVisible !== prevIsOpen) {
        setPrevIsOpen(isVisible);
        if (!isVisible) {
            trackAnimInCompleted.cancel();
            setIsAnimOut(true);
            trackAnimOutCompleted();
        }
        else {
            trackAnimOutCompleted.cancel();
            setIsAnimIn(true);
            trackAnimInCompleted();
        }
    }
    return (react_1["default"].createElement(exports.AnimationContext.Provider, __assign({ value: {
            isVisible: isVisible,
            isAnimOut: isAnimOut,
            isAnimIn: isAnimIn
        } }, otherProps)));
};
exports.AnimationProvider = AnimationProvider;
var useAnimation = function () {
    var context = react_1["default"].useContext(exports.AnimationContext);
    if (!context) {
        throw new Error("useAnimation must be used within a AnimationProvider");
    }
    return context;
};
exports.useAnimation = useAnimation;
//# sourceMappingURL=AppearanceAnim.js.map